import { ID } from '@state/base';

export interface ClientNotification {
  id: ID;
  message: string;
}

export const DISMISSED_COOKIE_NAME = 'dismissed_notifications';
